import { ReactNode } from 'react'
import { Button, ButtonProps, IconButton, IconButtonProps } from '@carto/meridian-ds/components'
import { ContextMenuBase } from './ContextMenuBase'
import { ContextMenuList } from './ContextMenuList'
import { ContextMenuBaseProps } from './interfaces'

interface ContextMenu extends ButtonProps, ContextMenuBaseProps {
  label: ReactNode
  isIcon?: boolean
  ariaLabel?: string
}

export function ContextMenu(props: ContextMenu) {
  const {
    label,
    menuItems,
    onClickItem,
    isOpen,
    placement,
    isIcon,
    popperClassName,
    fullWidth,
    disabled,
    elevation,
    alignRight,
    className,
    selected,
    ariaLabel,
    menuTitle,
    dense,
    extended,
    MenuListComponent = ContextMenuList,
    ...buttonProps
  } = props

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { endIcon, ...rest } = buttonProps
  const iconButtonProps = rest as IconButtonProps

  return (
    <ContextMenuBase
      menuItems={menuItems}
      selected={selected}
      onClickItem={onClickItem}
      placement={placement}
      popperClassName={popperClassName}
      fullWidth={fullWidth}
      elevation={elevation}
      alignRight={alignRight}
      className={className}
      ariaLabel={ariaLabel}
      isOpen={isOpen}
      menuTitle={menuTitle}
      dense={dense}
      extended={extended}
      MenuListComponent={MenuListComponent}
      ButtonComponent={({ onClick }) =>
        !isIcon ? (
          <Button {...buttonProps} disabled={disabled} onClick={onClick}>
            {label}
          </Button>
        ) : (
          <IconButton onClick={onClick} disabled={disabled} {...iconButtonProps} icon={label} />
        )
      }
    />
  )
}
